import { render, staticRenderFns } from "./SelectedAlarmsModal.vue?vue&type=template&id=652183a4&scoped=true&"
import script from "./SelectedAlarmsModal.vue?vue&type=script&lang=js&"
export * from "./SelectedAlarmsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectedAlarmsModal.vue?vue&type=style&index=0&id=652183a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652183a4",
  null
  
)

export default component.exports